import React from 'react'
import { NavLink } from 'react-router-dom'
import { Form } from '../components/Form'
import { Input } from '../components/Input'

export const LogIn = () => {
    return (
        <div className="wrapper df fade-in mtn mb jcc">
            <Form title={"Log In"} subtitle={"Enter your details"}>
                <Input hint={"Email"} type="email" placeholder="Saydullin@gmail.com" />
                <Input hint={"Password"} type="password" placeholder="********" />
                <NavLink to="/crowd-detection/personal-area" className={"except_under input_button"}>Done</NavLink>
                <NavLink to="/crowd-detection/signup" className={"bl-l fs-t"}>New here? Sign up!</NavLink>
            </Form>
        </div>
    )
}


